module.exports = __webpack_public_path__ + "img/evaluate_active_4.01e460d6.png";